import { Injectable, signal } from '@angular/core';
import { Observable, map, of, tap } from 'rxjs';
import { ApiService } from '../api.service';
import { Store } from '@ngrx/store';
import { DeviceService } from '../device.service';
import { ICountry } from '@libs/interfaces';
import { addGamesCategories, addGamesProviders } from '@libs/store/game/actions';
import { setTree } from '@libs/store/searcher/actions';
import { ISettingsApp, SettingsApp } from '@libs/helper/settings/settings-app.helper';

@Injectable({
  providedIn: 'root',
})
export class ResourcesService {
  countries = signal<ICountry[]>([]);
  settings: ISettingsApp = SettingsApp;
  bichoEnabled = signal<boolean>(true);
  private casinoResInit = false;
  constructor(
    private apiService: ApiService,
    private deviceService: DeviceService,
    private store: Store,
  ) {}

  /**
   * Fetches resources for users who are not logged in.
   * @returns {Observable<boolean>} An observable that emits true when the resources are fetched.
   */
  landing(): Observable<boolean> {
    return this.apiService.get(`resources/landing`).pipe(
      tap((data: any) => {
        const { geoip } = data;
        this.deviceService.geoip = geoip;
        this.bichoEnabled.set(data.bichoEnabled);
      }),
      map(Boolean),
    );
  }

  /**
   * Fetches resources for the Casino.
   * @returns {Observable<boolean>} An observable that emits true when the resources are fetched.
   */
  casino(): Observable<boolean> {
    if (this.casinoResInit) {
      return of(true);
    }
    return this.apiService.get(`resources/casino/${this.deviceService.device()}`).pipe(
      tap((data: any) => {
        this.store.dispatch(addGamesCategories({ categories: data.gamesCategories }));
        this.store.dispatch(addGamesProviders({ gamesProviders: data.gamesProviders }));
        this.store.dispatch(setTree({ tree: data.gameCatsTree }));
      }),
      tap(() => (this.casinoResInit = true)),
      map(Boolean),
    );
  }
}
